import React from 'react';
import { X } from 'lucide-react';
import { toEmailPreviewSrcDoc } from './eventBuildUtils';

export type PreviewItem = {
  templateName: string;
  subject: string;
  html: string;
};

interface Props {
  open: boolean;
  items: PreviewItem[];
  onClose: () => void;
}

const CampaignLivePreview: React.FC<Props> = ({ open, items, onClose }) => {
  if (!open || items.length === 0) return null;

  const gridCols =
    items.length >= 3
      ? 'xl:grid-cols-3 md:grid-cols-2 grid-cols-1'
      : items.length === 2
        ? 'lg:grid-cols-2 grid-cols-1'
        : 'grid-cols-1';

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-gray-900/50 dark:bg-black/60 p-2 sm:p-3 overflow-y-auto">
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-xl w-[calc(100vw-1rem)] sm:w-[calc(100vw-1.5rem)] max-w-none my-3 border border-gray-200 dark:border-slate-700 flex flex-col max-h-[96vh]">
        <div className="flex items-start justify-between gap-3 px-4 py-3 border-b border-gray-200 dark:border-slate-700">
          <div className="min-w-0">
            <p className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-slate-400">
              Preview{items.length > 1 ? ' all' : ''}
            </p>
            <p className="text-sm font-medium text-gray-900 dark:text-white mt-0.5 truncate">
              {items.map((i) => i.templateName).join(' · ')}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-slate-200 flex-shrink-0"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className={`p-3 bg-gray-100 dark:bg-slate-900/60 flex-1 min-h-0 overflow-auto grid gap-3 ${gridCols}`}>
          {items.map((item) => (
            <div
              key={item.templateName}
              className="rounded-md border border-gray-200 dark:border-slate-600 overflow-hidden bg-white dark:bg-slate-800 flex flex-col min-h-0 min-w-0"
            >
              <div className="px-3 py-2 border-b border-gray-200 dark:border-slate-700">
                <p className="text-xs font-medium text-gray-900 dark:text-white truncate">
                  {item.templateName}
                </p>
                <p className="text-[11px] text-gray-600 dark:text-slate-300 mt-0.5 line-clamp-2">
                  <span className="font-medium">Subject:</span> {item.subject || '(empty)'}
                </p>
              </div>
              <iframe
                title={`${item.templateName} preview`}
                className="email-preview-frame w-full h-[min(72vh,44rem)] bg-white border-0"
                sandbox=""
                srcDoc={toEmailPreviewSrcDoc(item.html)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CampaignLivePreview;
